import React from 'react';
import UserRoleSpecificContent from '../UserRoleSpecificContent.container';

/**
 * Generate Shortcut HOC for specific user roles conditions.
 * E.g. `<StylistSpecificContent/>` - render content for user with stylist role only
 * @param {Array|String} roles
 * @param {String} [validationType] - enum: include (default), exclude
 */
export default ({ roles, validationType = 'include' }) => ({ children }) => (
  <UserRoleSpecificContent roles={roles} validationType={validationType}>
    {children}
  </UserRoleSpecificContent>
);
